import { ComponentType } from "react";

import KpiCardJs from "../../../shared/Dashboard/KpiCard/KpiCard";
import type {
  ExportRow,
  PaymentReportingResponse,
} from "../../../../queries/payments/usePaymentReporting";
import { KPI_CARD_BACKGROUND } from "../../../../utils/Constants";
import { AppStrings } from "../../../../utils/constants/AppStrings";

import SectionHeader from "../SectionHeader/SectionHeader";

import styles from "./WithdrawalsSection.module.css";

// KpiCard is JS — cast for TS callers.
const KpiCard = KpiCardJs as ComponentType<{
  title: string;
  value: number;
  percentage?: number;
  rate?: boolean;
  isApiRunning?: boolean;
  maximumFractionDigits?: number;
  backgroundColor?: string;
  hidePercentage?: boolean;
  currencySymbol?: string;
}>;

type Withdrawals = PaymentReportingResponse["withdrawals"];

interface WithdrawalsSectionProps {
  withdrawals?: Withdrawals;
  isLoading?: boolean;
  exportRows?: ExportRow[];
  currencySymbol?: string;
}

const WithdrawalsSection: React.FC<WithdrawalsSectionProps> = ({
  withdrawals,
  isLoading = false,
  exportRows = [],
  currencySymbol,
}) => {
  const kpis = withdrawals?.kpis;

  return (
    <section className={styles.section}>
      <SectionHeader
        title={AppStrings.WITHDRAWALS}
        exportFilename="payment-reporting-withdrawals.xlsx"
        exportRows={exportRows}
      />
      <div className={styles.kpis}>
        <KpiCard
          title={AppStrings.TOTAL_WITHDRAWAL_AMOUNT}
          value={kpis?.total_amount.value ?? 0}
          percentage={kpis?.total_amount.percent_change}
          isApiRunning={isLoading}
          backgroundColor={KPI_CARD_BACKGROUND.GREY_750}
          currencySymbol={currencySymbol}
        />
        <KpiCard
          title={AppStrings.TOTAL_NUMBER_OF_WITHDRAWALS}
          value={kpis?.total_count.value ?? 0}
          percentage={kpis?.total_count.percent_change}
          isApiRunning={isLoading}
          maximumFractionDigits={0}
          backgroundColor={KPI_CARD_BACKGROUND.GREY_750}
        />
        <KpiCard
          title={AppStrings.ACCEPTANCE_RATE}
          value={kpis?.acceptance_rate.value ?? 0}
          percentage={kpis?.acceptance_rate.percent_change}
          isApiRunning={isLoading}
          rate
          maximumFractionDigits={0}
          backgroundColor={KPI_CARD_BACKGROUND.GREY_750}
        />
      </div>
    </section>
  );
};

export default WithdrawalsSection;
